'use es6';

import { UTK_COOKIE, UTK_LEGACY_COOKIE, SESSION_COOKIE, SESSION_RESTART_COOKIE } from 'cookie-banner/constants/trackingCookies';
const START_MILLIS = 1536223200000;
const END_MILLIS = 1536251400000;
export default class CritsitCookieHandler {
  /**
   * The Sept 6 critsit caused customers with privacy policy banners to have their
   * settings deleted, and therefore set cookies without getting consent first.
   *
   * This helper's objective is to remove any cookies that were set during the window
   * that the customer expected to have a banner showing prior to cookie placement.
   */

  static handle(cookie, matchedCookiePolicy) {
    if (!matchedCookiePolicy.active) {
      return;
    }
    const cookieParts = cookie.get(UTK_COOKIE).split('.');
    const isNewUtk = cookieParts.length === 1 && cookieParts[0].length > 0;
    if (isNewUtk) {
      return;
    }
    if (cookieParts.length !== 6 || !cookieParts[1].length > 0) {
      return;
    }
    const cookiePlacementTime = cookieParts[2];
    if (cookiePlacementTime < START_MILLIS || cookiePlacementTime > END_MILLIS) {
      return;
    }
    cookie.remove(UTK_COOKIE);
    cookie.remove(UTK_LEGACY_COOKIE);
    cookie.remove(SESSION_COOKIE);
    cookie.remove(SESSION_RESTART_COOKIE);
  }
}